<template>
  <Dropdown placement="bottomLeft">
    <MIcon :size="18" prefix="g" icon="jilu" color="#01A887" />

    <template #overlay>
      <Menu v-model:selected-keys="selectKeys" @click="handleMenuClick">
        <Menu.Item disabled>
          <span class="text-[#8991A1]">{{ t('g.25090012') }}</span>
        </Menu.Item>
        <Menu.Item v-for="item in getTabsState" :key="item.query ? item.fullPath : item.path">
          {{ t(item.meta.title) }}
        </Menu.Item>
      </Menu>
    </template>
  </Dropdown>
</template>
<script setup lang="ts">
  import { Dropdown, Menu } from 'ant-design-vue';
  import { computed, ref, unref } from 'vue';
  import { useRouter } from 'vue-router';
  import type { RouteLocationNormalized, RouteMeta } from 'vue-router';
  import { t } from '@mts/hooks/web/useI18n';
  import { useGo } from '@mts/hooks/web/usePage';
  import { listenerRouteChange } from '@mts/logics/mitt/routeChange';
  import { REDIRECT_NAME } from '@/router/constant';
  import { getMultipleTabStore } from '@/store';

  const router = useRouter();
  const tabStore = getMultipleTabStore();
  const selectKeys = ref<string[]>([]);
  listenerRouteChange((route) => {
    const { name } = route;
    if (name === REDIRECT_NAME || !route) {
      return;
    }
    const { path, fullPath, meta = {} } = route;
    const { currentActiveMenu, hideTab } = meta as RouteMeta;
    const isHide = !hideTab ? null : currentActiveMenu;
    const p = isHide || fullPath || path;
    if (!selectKeys.value.includes(p)) {
      selectKeys.value = [p];
    }
    if (isHide) {
      const findParentRoute = router.getRoutes().find((item) => item.path === currentActiveMenu);
      findParentRoute && tabStore.addTab(findParentRoute as unknown as RouteLocationNormalized);
    } else {
      tabStore.addTab(unref(route));
    }
  });

  const getTabsState = computed(() => {
    return tabStore.getTabList.filter(
      (item) => !item.meta?.hideTab && item.href === '#' + item.fullPath,
    );
  });

  const go = useGo();
  const handleMenuClick = ({ key }) => {
    go(key, false);
  };
</script>
